import React, { useState } from 'react';
import styles from '../styles/Contact.module.css';
import { useI18n } from '../i18n/I18nContext';

const publicUrl = process.env.PUBLIC_URL || '';
const contactImage = `${publicUrl}/images/breads/dinkel-bread1.webp`;
const backendUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';

const Contact = () => {
  const [submitState, setSubmitState] = useState('idle');
  const { t } = useI18n();

  const handleSubmit = async event => {
    event.preventDefault();
    setSubmitState('sending');

    const formData = new FormData(event.currentTarget);
    const payload = {
      name: formData.get('name'),
      email: formData.get('email'),
      message: formData.get('message'),
    };

    try {
      const response = await fetch(`${backendUrl}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Contact request failed.');
      }

      event.currentTarget.reset();
      setSubmitState('sent');
    } catch (error) {
      setSubmitState('error');
    }
  };

  return (
    <main className={styles.page}>
      <header className={styles.hero}>
        <p className={styles.eyebrow}>{t('pages.contact.eyebrow')}</p>
        <h1>{t('pages.contact.title')}</h1>
        <p>{t('pages.contact.intro')}</p>
      </header>

      <section className={styles.content} aria-label="Contact information and form">
        <div className={styles.details} style={{ '--contact-image': `url('${contactImage}')` }}>
          <p className={styles.sectionLabel}>{t('pages.contact.sectionLabel')}</p>
          <h2>{t('pages.contact.heading')}</h2>
          <p className={styles.description}>{t('pages.contact.description')}</p>

          <div className={styles.contactBox}>
            <div>
              <span className={styles.label}>Location</span>
              <span>Sofia, Bulgaria</span>
            </div>
            <div>
              <span className={styles.label}>Phone</span>
              <a href="tel:+359497681666">00359 (049) 768 1666</a>
            </div>
          </div>
        </div>

        <form className={styles.form} onSubmit={handleSubmit}>
          <p className={styles.sectionLabel}>{t('pages.contact.sendLabel')}</p>
          <h2 className={styles.formTitle}>{t('pages.contact.formTitle')}</h2>
          <div className={styles.fieldRow}>
            <label>
              {t('pages.contact.name')}
              <input name="name" type="text" autoComplete="name" required />
            </label>
            <label>
              {t('pages.contact.email')}
              <input name="email" type="email" autoComplete="email" required />
            </label>
          </div>
          <label>
            {t('pages.contact.message')}
            <textarea name="message" rows="6" required />
          </label>
          <button type="submit" disabled={submitState === 'sending'}>
            {submitState === 'sending' ? t('pages.contact.sending') : t('pages.contact.send')}
          </button>
          {submitState === 'sent' && <p className={styles.success}>{t('pages.contact.success')}</p>}
          {submitState === 'error' && <p className={styles.error}>{t('pages.contact.error')}</p>}
        </form>
      </section>
    </main>
  );
};

export default Contact;
